/**
 * @description defines routes for the contracts page
 */

import React from 'react';

import AssignContractPersonnel from '@seccon/pages/assignContractPersonnel';

export default [
  {
    path: 'contract/assignPersonnel/:contractId',
    element: (
      <AssignContractPersonnel />
    )
  }
];
